import React from 'react'
import ProfileContainer from './ProfileContainer'

const Profile = (props) => (
  <ProfileContainer {...props} />
)

export default Profile



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/index.js